var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shuping",class:{ active: _vm.active }},[_c('p',[_vm._v(_vm._s(_vm.txt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }